'use client'

import { Capacitor, registerPlugin } from '@capacitor/core'
import { createNativeIdTokenNonce, type NativeIdTokenNonce } from '@/lib/native-id-token-nonce'

export interface NativeAppleFullName {
  givenName?: string
  familyName?: string
}

export interface NativeAppleAuthPlugin {
  signIn: (input?: { nonce?: string }) => Promise<{
    idToken: string
    fullName?: NativeAppleFullName
  }>
}

export type AppleIdTokenNonce = NativeIdTokenNonce

export const NativeAppleAuth = registerPlugin<NativeAppleAuthPlugin>('NativeAppleAuth')

export function isNativeAppleAuthAvailable(): boolean {
  if (typeof window === 'undefined') return false

  return Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('NativeAppleAuth')
}

export function useNativeAppleAuthAvailability(isNativeApp: boolean): boolean {
  return isNativeApp && isNativeAppleAuthAvailable()
}

export async function createAppleIdTokenNonce(): Promise<AppleIdTokenNonce> {
  return createNativeIdTokenNonce()
}

export async function signInWithNativeApple(input?: { nonce?: string }): Promise<{
  idToken: string
  fullName?: NativeAppleFullName
}> {
  return NativeAppleAuth.signIn(input)
}
